import { HERO_TEXT } from "../constants";

const Hero = () => {
    return (
        <div>
            {/* <p className="hero light-chocolate d-none d-md-block heading-1" align="center">
                {HERO_TEXT}
            </p>
            <p className="hero light-chocolate d-md-none content-1" align="center">
                {HERO_TEXT}
            </p> */}

            <p className="hero light-chocolate heading-1" align="center">
                {HERO_TEXT}
            </p>
        </div>
    );
}

export default Hero;